import React, { Component } from "react";
import { Empty, message, Popconfirm, Spin, Tag, Tooltip } from "antd";
import { CheckCircleOutlined, FileProtectOutlined, RiseOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, ModalItem, TableItem } from "../../../Components/Items";
import { textoLimitesPaquete, textoPrecioMensual, textoPrecioPaquete } from "./paqueteIaTextos";

moment.locale("es");

class AvisoIa extends Component {
  state = {
    loading: false,
    empresas: [],
    urlAviso: "",
    empresaAviso: null,
    aceptando: false,
    empresaPaquete: null,
    paquetesEmpresa: [],
    cargandoPaquetes: false,
  };

  abrirSubirPaquete = async (empresa) => {
    this.setState({ empresaPaquete: empresa, paquetesEmpresa: [], cargandoPaquetes: true });
    try {
      const res = await axios.post("ia/selectPaquetesIaEmpresa", { empresaId: empresa._id }, { headers: this.props.headersToken });
      if (res.data.success === 2) {
        this.setState({ paquetesEmpresa: res.data.data });
      } else {
        message.error(res.data.message || "No se pudieron consultar los paquetes");
      }
    } catch (error) {
      message.error("No se pudieron consultar los paquetes");
    }
    this.setState({ cargandoPaquetes: false });
  };

  subirPaquete = async (paquete) => {
    this.setState({ cargandoPaquetes: true });
    try {
      const res = await axios.post(
        "ia/subirPaqueteIa",
        { empresaId: this.state.empresaPaquete._id, paqueteIaId: paquete._id },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        message.success(res.data.message);
        this.setState({ empresaPaquete: null, paquetesEmpresa: [] });
        this.consultarEmpresas();
      } else {
        message.error(res.data.message || "No se pudo cambiar el paquete");
      }
    } catch (error) {
      message.error("No se pudo cambiar el paquete");
    }
    this.setState({ cargandoPaquetes: false });
  };

  componentDidMount() {
    this.consultarEmpresas();
  }

  componentDidUpdate(prevProps) {
    if (this.props.activo && !prevProps.activo) this.consultarEmpresas();
  }

  consultarEmpresas = async () => {
    this.setState({ loading: true });
    try {
      const res = await axios.post("ia/selectEmpresasIa", {}, { headers: this.props.headersToken });
      if (res.data.success === 2) {
        this.setState({ empresas: res.data.data, urlAviso: res.data.urlAviso });
      } else {
        message.error(res.data.message || "No se pudieron consultar las empresas");
      }
    } catch (error) {
      message.error("No se pudieron consultar las empresas");
    }
    this.setState({ loading: false });
  };

  aceptarAviso = async () => {
    const empresa = this.state.empresaAviso;
    if (!empresa) return;
    this.setState({ aceptando: true });
    try {
      const res = await axios.post("ia/aceptarAvisoIa", { empresaId: empresa._id }, { headers: this.props.headersToken });
      if (res.data.success === 2) {
        message.success("Aviso aceptado");
        this.setState({ empresaAviso: null });
        this.consultarEmpresas();
      } else {
        message.error(res.data.message || "No se pudo aceptar el aviso");
      }
    } catch (error) {
      message.error("No se pudo aceptar el aviso");
    }
    this.setState({ aceptando: false });
  };

  render() {
    const columns = [
      {
        title: "Empresa",
        dataIndex: "nombre",
        key: "nombre",
        render: (value, record) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontWeight: "bold" }}>{value}</span>
            <span style={{ fontSize: 12, color: "#888" }}>{record.rfc}</span>
          </div>
        ),
      },
      {
        title: "Paquete de IA",
        dataIndex: "paquete",
        key: "paquete",
        render: (paquete) =>
          paquete ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontWeight: 600 }}>{paquete.nombre}</span>
              <span style={{ fontSize: 12, color: "#888" }}>{textoLimitesPaquete(paquete)}</span>
              <span style={{ fontSize: 12, color: "#888" }}>{textoPrecioPaquete(paquete)}</span>
            </div>
          ) : (
            <Tag color="red">Sin paquete</Tag>
          ),
      },
      {
        title: "Aviso de uso de IA",
        dataIndex: "avisoAceptado",
        key: "avisoAceptado",
        width: 180,
        render: (value) =>
          value ? <Tag color="green">Aceptado</Tag> : <Tag color="orange">Pendiente</Tag>,
      },
      {
        title: "Aceptado por",
        dataIndex: "aceptadoPor",
        key: "aceptadoPor",
        responsive: ["md"],
      },
      {
        title: "Fecha",
        dataIndex: "fechaAceptacion",
        key: "fechaAceptacion",
        responsive: ["md"],
        render: (value) => (value ? moment(value).format("LLL") : ""),
      },
      {
        title: "Acción",
        key: "accion",
        width: 110,
        render: (_, record) => (
          <div className="acciones-container">
            {record.avisoAceptado ? (
              <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 18 }} />
            ) : (
              <Tooltip title="Aceptar aviso de uso de IA" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem type="default" size="small" cyan icon={<FileProtectOutlined />} onClick={() => this.setState({ empresaAviso: record })} />
              </Tooltip>
            )}
            <Tooltip title="Cambiar paquete de IA" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem type="default" size="small" morado icon={<RiseOutlined />} onClick={() => this.abrirSubirPaquete(record)} />
            </Tooltip>
          </div>
        ),
      },
    ];

    return (
      <>
        <p style={{ color: "#555" }}>
          Empresas con la integración de IA activada. Mientras el aviso no se acepte, nadie de esa empresa podrá usar la IA.
        </p>
        <TableItem size="small" rowKey="_id" dataSource={this.state.empresas} columns={columns} loading={this.state.loading} pagination={false} />
        <ModalItem
          title={
            <span>
              <FileProtectOutlined style={{ marginRight: 8 }} />
              Aviso de uso de IA
            </span>
          }
          visible={Boolean(this.state.empresaAviso)}
          onCancel={() => this.setState({ empresaAviso: null })}
          onOk={this.aceptarAviso}
          confirmLoading={this.state.aceptando}
          footer
          okText="Acepto"
          width={560}
          paddingTop
        >
          <h3>{this.state.empresaAviso?.nombre}</h3>
          <p>
            Al aceptar, los usuarios que autorices podrán consultar información de esta empresa desde un asistente de IA externo
            (por ejemplo Claude o ChatGPT), solo con las funciones que les asignes.
          </p>
          <ul>
            <li>Las consultas son de solo lectura: el asistente no puede crear, modificar ni borrar información.</li>
            <li>Cada usuario solo ve esta empresa, las funciones que le asignes y los proyectos que tenga permitidos.</li>
            <li>La información consultada se envía al proveedor del asistente de IA y se rige también por sus términos.</li>
            <li>Todas las consultas quedan registradas en la bitácora de IA.</li>
          </ul>
          <p>
            Consulta el{" "}
            <a href={this.state.urlAviso} target="_blank" rel="noopener noreferrer">
              aviso de privacidad de BIWO
            </a>
            .
          </p>
        </ModalItem>
        <ModalItem
          title={"Paquete de IA — " + (this.state.empresaPaquete?.nombre || "")}
          visible={Boolean(this.state.empresaPaquete)}
          onCancel={() => this.setState({ empresaPaquete: null, paquetesEmpresa: [] })}
          footer={null}
          destroyOnClose
          spinning={false}
          width={900}
          paddingTop
        >
          <Spin spinning={this.state.cargandoPaquetes}>
            <div className="paquetes-ia-encabezado">
              <span>Puedes cambiar a un paquete mayor cuando quieras; aplica de inmediato. Para bajar de paquete contacta a BIWO.</span>
            </div>
            {this.state.paquetesEmpresa.length === 0 ? (
              <Empty description={this.state.cargandoPaquetes ? "Cargando..." : "No hay paquetes disponibles"} />
            ) : (
              <div className="paquetes-ia-grid">
                {this.state.paquetesEmpresa.map((paquete) => (
                  <div key={paquete._id} className={"paquete-ia-tarjeta" + (paquete.actual || paquete.disponible ? "" : " paquete-ia-inactivo")}>
                    <div className="paquete-ia-titulo">
                      <span>{paquete.nombre}</span>
                      {paquete.actual && <Tag color="purple">Tu paquete</Tag>}
                    </div>
                    <div className="paquete-ia-descripcion">{paquete.descripcion || ""}</div>
                    <div className="paquete-ia-precio">
                      {Number(paquete.precioMensual || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN" })}
                      <span> / mes</span>
                    </div>
                    <div className="paquete-ia-iva">Precio sin IVA</div>
                    <div className="paquete-ia-limites">
                      {paquete.sinLimite ? (
                        <div><span>Consultas</span><b>Sin límite</b></div>
                      ) : (
                        <>
                          <div><span>Diarias</span><b>{Number(paquete.consultasDiarias || 0).toLocaleString("es-MX")}</b></div>
                          <div><span>Mensuales</span><b>{Number(paquete.consultasMensuales || 0).toLocaleString("es-MX")}</b></div>
                        </>
                      )}
                    </div>
                    <div className="paquete-ia-pie">
                      {paquete.actual ? (
                        <span>Paquete actual</span>
                      ) : paquete.disponible ? (
                        <Popconfirm
                          title={`¿Cambiar al paquete ${paquete.nombre} por ${textoPrecioMensual(paquete.precioMensual)}? Para regresar a uno menor tendrás que contactar a BIWO.`}
                          onConfirm={() => this.subirPaquete(paquete)}
                          okText="Sí"
                          cancelText="No"
                        >
                          <ButtonItem type="primary" size="small" block>
                            Elegir este paquete
                          </ButtonItem>
                        </Popconfirm>
                      ) : (
                        <span>Para bajar a este paquete contacta a BIWO</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Spin>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(AvisoIa);
